/* eslint-disable import/prefer-default-export */
import React from 'react';
import dayjs from '../../../../../dayjs/dayjs_timezone';
import { flatten, formatAvailabilityMessage } from '../../../../utilities/helperUtility';
import { stringToBoolean } from '../../../../utilities/conversionUtility';
import SlotLabel from '../../SlotLabel';
import Translation from '../../../../utilities/localizationUtility';

function getAvailabilityMessage(
  slots,
  flatSlots,
  capacity,
  capacityType,
  loading,
  settings,
  variant,
  details,
) {
  const t = new Translation(settings);
  const { setting = {} } = settings;
  const isShowRemainingSpace = stringToBoolean(setting.show_remaining_places);
  const unitMultiplier = variant?.unit_multiplier || 1;
  let totalAvailability = capacity;

  if (loading || !isShowRemainingSpace) {
    return null;
  }

  if (slots.some((slot) => slot.availability.every((a) => a.status !== 1))) {
    totalAvailability = 0;
  } else {
    switch (capacityType) {
      case 0:
        if (slots[0]) {
          const { availability } = slots[0];
          for (let i = 0; i < availability.length; i++) {
            totalAvailability -= availability[i].bookings;
          }
        }
        break;
      case 1:
      case 2:
        totalAvailability = Math.min(...flatSlots.map((x) => x.available));
        break;
      // no default
    }
  }

  totalAvailability = parseInt(totalAvailability / unitMultiplier, 10);

  return (
    <p className="custom-option-description">
      {formatAvailabilityMessage(totalAvailability, totalAvailability, t)}
      {details && (
        <span style={{ float: 'right' }}>
          <SlotLabel option={{ label: '', details }} />
        </span>
      )}
    </p>
  );
}

export function getTermOptions(props) {
  const {
    capacity,
    capacityType,
    flattenTimeSlots,
    mindate,
    quantity,
    selectedLocation,
    selectedResource,
    terms,
    variants = {},
    variantSelected,
  } = props;

  if (!variantSelected) {
    return [];
  }

  const variant = variants[variantSelected];
  const unitMultiplier = variant?.unit_multiplier || 1;
  const totalQuantity = quantity * unitMultiplier;
  const minDate = dayjs().add(mindate, 'seconds');

  const options = terms.filter(
    (term) => dayjs(term.start_date) >= dayjs()
    && (!selectedLocation || !term.location_id || term.location_id === selectedLocation.id), // filtered by location
  ).map((term) => {
    const slots = flattenTimeSlots.filter((x) => x.term_id === term.id);
    const flatSlots = flatten(slots.map((x) => x.availability.filter((v) => v.external_id === variantSelected)));
    let sumEachVariantMaxBooking = 0;

    if (capacityType === 0 && slots[0]) {
      slots[0].availability.forEach((availability) => {
        sumEachVariantMaxBooking += availability.bookings;
      });
    }

    const unavailableSlot = flatSlots.find((x) => x.status_detail?.source_urls);
    const details = unavailableSlot?.status_detail;

    return {
      ...term,
      label: <>
              <p>{term.name}</p>
              {getAvailabilityMessage(
                slots,
                flatSlots,
                capacity,
                capacityType,
                props.loading,
                props.settings,
                variant,
                details,
              )}
             </>,
      maxAvailability: Math.min(...flatSlots.map((x) => x.available)),
      disabled:
        capacity < sumEachVariantMaxBooking + totalQuantity
        || !slots.length
        || flatSlots.some((x) => x.available < totalQuantity)
        || slots.some((x) => x.unavailable_resources.includes(selectedResource?.id))
        || slots.some((x) => dayjs(x.start).isBefore(minDate))
        || dayjs(term.start_date).isBefore(minDate),
    };
  });

  return options.sort((x, y) => (dayjs(y.start_date).isSameOrAfter(dayjs(x.start_date)) ? -1 : 1));
}
